export default "__VITE_ASSET__BSiL1RLQ__"